module.exports = __webpack_public_path__ + "img/coin.66c2efb0.png";